var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ReportsApi } from '../../../api/reports-api';
import { ReportHelper } from '../../report-helper';
export class ProjectDetailReportComponent {
    constructor(reportsApi, reportHelper, route, titleService) {
        this.reportsApi = reportsApi;
        this.reportHelper = reportHelper;
        this.route = route;
        this.districtInformation = {};
        this.isGenerating = false;
        this.error = false;
        this.errorMessage = this.reportHelper.reportErrorMessages.noReportData;
        titleService.setTitle(titleService.getTitle() + ' : Project Detail Report');
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.isGenerating = true;
            this.route.paramMap.subscribe(x => {
                this.projectId = JSON.parse(window.localStorage.getItem(x.get('id'))).projectId;
                this.loadReport();
            });
        });
    }
    loadReport() {
        return __awaiter(this, void 0, void 0, function* () {
            this.isGenerating = true;
            yield this.reportsApi.getProjectDetailReportData(this.projectId).then((reportData) => {
                this.reportData = reportData;
            }, (error) => {
                this.isGenerating = false;
                this.error = true;
            });
            yield this.getDistrictInformation(this.reportData.projectDetail);
            this.isGenerating = false;
        });
    }
    getDistrictInformation(data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.districtInformation.congress = yield this.reportHelper.getCongressionalDistrictByName(parseInt(data.congresS_DISTRICTS, 10));
            this.districtInformation.senate = yield this.reportHelper.getSenateDistrictByName(parseInt(data.senatE_DISTRICTS, 10));
            this.districtInformation.house = yield this.reportHelper.getHouseDistrictByName(parseInt(data.housE_DISTRICTS, 10));
        });
    }
}
